import React from 'react';

/* Tiny inline sparkline for a drawn line — the orange stroke is your call,
   the ink stroke is reality so far. Rides along in list rows. */
export default function CurveSpark({ points, marks, startValue, startDate, horizonWeeks, width = 54, height = 26 }) {
  if (!Array.isArray(points) || !points.length || !startValue) return null;

  const you = [startValue, ...points];
  const real = [{ week: 0, value: startValue }];
  if (startDate && Array.isArray(marks)) {
    for (const m of marks) {
      if (m.value == null) continue;
      const week = (new Date(`${m.date}T12:00:00Z`) - new Date(`${startDate}T12:00:00Z`)) / (7 * 86400000);
      real.push({ week: Math.min(Math.max(week, 0), horizonWeeks), value: m.value });
    }
  }

  const all = you.concat(real.map((r) => r.value));
  const lo = Math.min(...all);
  const hi = Math.max(...all);
  const span = Math.max(hi - lo, 1);
  const P = 3;
  const x = (week) => P + (week / Math.max(horizonWeeks, 1)) * (width - 2 * P);
  const y = (v) => height - P - ((v - lo) / span) * (height - 2 * P);

  const youPts = you.map((v, i) => `${x(i).toFixed(1)},${y(v).toFixed(1)}`).join(' ');
  const realPts = real.map((r) => `${x(r.week).toFixed(1)},${y(r.value).toFixed(1)}`).join(' ');
  const last = real[real.length - 1];

  return (
    <svg viewBox={`0 0 ${width} ${height}`} style={{ width, height, flex: 'none' }} aria-hidden="true">
      <polyline points={youPts} fill="none" stroke="#FF7A00" strokeWidth="2" strokeLinecap="round" opacity=".9" />
      {real.length > 1 ? (
        <>
          <polyline points={realPts} fill="none" stroke="#1D1D1F" strokeWidth="2" strokeLinecap="round" />
          <circle cx={x(last.week)} cy={y(last.value)} r="2.4" fill="#1D1D1F" />
        </>
      ) : (
        <circle cx={x(0)} cy={y(startValue)} r="2.4" fill="#1D1D1F" />
      )}
    </svg>
  );
}
